var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_home act-text-stroke",on:{"click":function($event){return _vm.$goPage(_vm.url || 'index', _vm.$route.query)}}},[_c('img',{attrs:{"src":"http://assets.rurushishi.com/activies/yy-act-202409/goBack.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }